module.exports = __webpack_public_path__ + "img/process-tank-icon.f8188a6e.svg";